export const demandTypesQueryKeys = {
  all: () => ['/demand-types'] as const,
  lists: () => [...demandTypesQueryKeys.all(), 'list'] as const,
};
